import {
    BEGIN_AJAX_CALL,
    END_AJAX_CALL
} from '../../constants/actionType';
import {
    getAccountListApi,
    getInfomoViewListApi
} from "../../api/connectionManager";

export const getInfomoViewListAction = ({ tenantId, authToken, userId, params = {}, payload = {} }) => async dispatch => {
    let infomoSeatsData = {};
    try {
        dispatch({
            type: BEGIN_AJAX_CALL,
            showSpinner: true,
        });
        infomoSeatsData = await getInfomoViewListApi({ tenantId, authToken, userId, params, payload });
        return infomoSeatsData;
    } catch (err) {
    } finally {
        dispatch({
            type: END_AJAX_CALL,
            showSpinner: false,
        });
    }
};


export const getTenantAccountListAction = ({ tenantId, authToken, userId, params = {}}) => async dispatch => {
    let infomoSeatsData = {};
    try {
        dispatch({
            type: BEGIN_AJAX_CALL,
            showSpinner: true,
        });
        infomoSeatsData = await getAccountListApi({ tenantId, authToken, userId, params });
        return infomoSeatsData;
    } catch (err) {
    } finally {
        dispatch({
            type: END_AJAX_CALL,
            showSpinner: false,
        });
    }
};

// '/beki/seat/custom?list=account'